import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  FamilyRequest,
} from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitFamily = createAsyncThunk<
  FamilyRequest,
  FamilyRequest,
  ThunkApi
>("submitFamily", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addFamily(args);
    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error = {
      title: "Salvataggio nucleo familiare",
      description:
        "Non siamo riusciti a salvare il tuo nucleo familiare.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
